import { useContext } from "react";
import { Flex, Image } from "@inntechcorp/it-design";

import { GetLocalState } from "Connectivity/LocalStorage";
import WebContext from "Context/WebContext";
import ImageReplacer from "Helpers/replacer/ImageReplacer";

const useModalActions = () => {
  
  const { ShowModal, isMobile } = useContext(WebContext);

  const showLoginModal = () => {

    const imgSrc  = GetLocalState('assets').images.SignInImage;
    const logoSrc = GetLocalState('assets').logos.Modal;

    ShowModal(
      "signin-modal",
      "signin",
      {
        addContentBefore      : (
          <Flex justify="center" align="center">
            <Image
              src     = {imgSrc}
              source  = {ImageReplacer(imgSrc)}
              width   = "auto"
              height  = "145"
            />
          </Flex>
        ),
        className             : "signin-modal",
        beforeContentPadding  : "0",
        contentPadding        : isMobile ? "1.5rem" : "2rem",
        outerPadding          : isMobile ? "0"      : "3.125rem",
        width                 : isMobile ? "100%"   : "25rem",
        title                 : (
          <Image
            src     = {logoSrc}
            source  = {ImageReplacer(logoSrc)}
            height  = "40"
          />
        )
      }
    );

  }

  const showForgotPasswordModal = () => {

    ShowModal(
      "forgot-password-modal",
      "forgotpassword",
      {
        className             : "forgot-password-modal",
        beforeContentPadding  : "0",
        contentPadding        : isMobile ? "1.5rem" : "2rem",
        outerPadding          : isMobile ? "0"      : "3.125rem",
        width                 : isMobile ? "100%"   : "25rem",
        customProps           : {
          onlyLiveChat : GetLocalState("settings").ForgotPasswordAction === "live-support"
        }
      }
    );

  }

  const showSignUpModal = () => {

    const logoSrc = GetLocalState('assets').logos.Modal;

    ShowModal("signup-modal", "signup", {
      className               : "signup-modal",
      contentPadding          : isMobile ? "1.5rem" : "2rem",
      outerPadding            : isMobile ? "0"      : "3.125rem",
      width                   : isMobile ? "100%"   : "43.75rem",
      title                   : (
        <Image
          src     = {logoSrc}
          source  = {ImageReplacer(logoSrc)}
          height  = "40"
        />
      )
    });

  }

  return {
    showLoginModal,
    showSignUpModal,
    showForgotPasswordModal
  }
  
}

export default useModalActions;